(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nf-bundle-contents"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function init(root) {
      if (root.dataset.nfBundleInit === '1') return;
      // Quick-add modal: only render when the block opts in via the
      // "Show in quick-add modal" setting (data-qa-enabled="1"). When off
      // (default), skip — the block is PDP-only and CSS also hides it, so we
      // avoid the wasteful Storefront fetch.
      var inQuickAdd = !!(root.closest && root.closest('quick-add-modal, .quick-add-modal, .quick-add'));
      if (inQuickAdd && root.dataset.qaEnabled !== '1') {
        root.dataset.nfBundleInit = '1';
        return;
      }
      root.dataset.nfBundleInit = '1';

      var grid = root.querySelector('[data-nf-bundle-grid]');
      var extrasTpl = root.querySelector('[data-nf-bundle-extras]');
      if (!grid) return;

      // Scope variant lookups to THIS block's product context. Inside a
      // quick-add modal there are multiple product-info elements (the modal
      // PLUS the page behind it), so querying the global document would track
      // the wrong product's variant. Prefer the enclosing quick-add modal,
      // else the enclosing product-info/product container, else document.
      var scopeEl = (root.closest && (root.closest('quick-add-modal, .quick-add-modal, .quick-add')
        || root.closest('product-info, .product__info-container, .product, #MainProduct'))) || document;

      // Position-based display overrides: index 0 = first card, 1 = second, …
      // Each entry is { title, variant }; blank fields keep the auto value.
      var overrides = [];
      var ovrEl = root.querySelector('[data-nf-bundle-overrides]');
      if (ovrEl) {
        try { overrides = JSON.parse(ovrEl.textContent || '[]') || []; } catch (e) { overrides = []; }
      }

      var cfg = {
        handle: root.dataset.productHandle,
        url: root.dataset.graphqlUrl,
        token: root.dataset.storefrontToken,
        country: (root.dataset.country || 'US').toUpperCase(),
        lang: (root.dataset.lang || 'EN').toUpperCase(),
        localeTag: root.dataset.localeTag || 'en',
        // Per-template price visibility. Hides every MONEY amount in the block
        // (component cards, free-shipping value, gift-card value) while keeping
        // labels and non-money text like "Included". Defaults to shown, so a
        // missing/absent attribute can never silently strip prices.
        showPrices: root.dataset.showPrices !== '0',
        setOf: root.dataset.setOf || 'Set of',
        // One card per variant instead of a single "Set of A - B" card. Off by
        // default so existing bundles keep the card count they were designed
        // around; it is a per-template setting.
        splitVariants: root.dataset.splitVariants === '1',
        // "Full title => Short label" rules, semicolon separated. Sorted longest-first
        // so a broad rule cannot shadow a more specific one.
        titleReplacements: (root.dataset.titleReplacements || '')
          .split(';')
          .map(function (l) { return l.split('=>'); })
          .filter(function (p) { return p.length === 2 && p[0].trim() && p[1].trim(); })
          .map(function (p) { return [p[0].trim(), p[1].trim()]; })
          .sort(function (a, b) { return b[0].length - a[0].length; }),
        fsEnabled: root.dataset.fsEnabled === '1',
        fsImage: root.dataset.fsImage || '',
        fsLabel: root.dataset.fsLabel || 'Free shipping!',
        // Free-shipping threshold + saved-shipping value are computed
        // server-side (Liquid, from localization.country) in the ACTIVE
        // presentment currency, so they match the bundle price's currency.
        // The saved value is formatted client-side via fmtMoney (Intl) so it
        // matches the component card prices exactly (comma decimal etc.).
        fsThreshold: parseInt(root.dataset.fsThreshold, 10) || 0,
        fsShipCents: parseInt(root.dataset.fsShipCents, 10) || 0,
        fsShipCurrency: root.dataset.fsShipCurrency || 'EUR',
        // Welcome Bundle grant: variant ids (M/L of `starter_bundle` products)
        // that ship free in EVERY market — enforced at checkout by the
        // starter-bundle-free-shipping discount function. See Liquid above.
        fsGrantIds: (function () {
          try { return JSON.parse(root.dataset.fsGrantIds || '[]') || []; }
          catch (e) { return []; }
        })(),
        // "Friend Gift" free gift-card card (metafield-driven, EUR face value).
        giftEnabled: root.dataset.giftEnabled === '1',
        giftValue: parseFloat(root.dataset.giftValue) || 0,
        giftCurrency: root.dataset.giftCurrency || 'EUR',
        giftImage: root.dataset.giftImage || '',
        giftLabel: root.dataset.giftLabel || 'Free gift card!',
        // "Expert plant support" value card (clickable → popup with the
        // support promise). Per-page toggle; no price ("Included").
        esEnabled: root.dataset.esEnabled === '1',
        esImage: root.dataset.esImage || '',
        esLabel: root.dataset.esLabel || 'Expert plant support',
        esPrice: root.dataset.esPrice || 'Included',
        esIntro: root.dataset.esIntro || '',
        esBullets: [root.dataset.esB1, root.dataset.esB2, root.dataset.esB3].filter(function (b) { return b; })
      };

      // B2B context: never show market shipping messaging here (B2B has its
      // own wholesale pricing/shipping). Bail on either signal.
      var isB2B = false;
      try { isB2B = !!(window.SybotanicaB2B && (window.SybotanicaB2B.isB2B || window.SybotanicaB2B.isB2BPage)); } catch (e) {}

      // ---- Per-country free-shipping refinement (English ROOT only) ----------
      // The server bakes fsShipCents from localization.country, which falls back
      // to the Ireland default (€9.95) for EUR countries that aren't regions of
      // the primary market (NL/BE/AT/FI/IT/ES) — so the card showed IE's cost
      // until a localization toggle forced a re-render (the "future hook" noted
      // in the Liquid above). The geo bridge (assets/syba-geo-country-bridge.js)
      // publishes the detected country to window.SybaDetectedCountry +
      // localStorage + a 'syba:geo-country' event; we look its ship cost up in
      // SybaGiftConfigTable (the SAME source the cart shipping line uses, so the
      // two always agree) and apply it before first render + on the event.
      // Guards: default root only (a real market subfolder is authoritative);
      // currency must match (never show a SEK/DKK figure in the EUR root); never
      // in B2B (already bailed on the card).
      var ON_DEFAULT_ROOT = (function () {
        try { return !(window.Shopify && window.Shopify.routes && window.Shopify.routes.root && window.Shopify.routes.root !== '/'); }
        catch (e) { return true; }
      })();
      function detectedIso() {
        try { if (window.SybaDetectedCountry) return String(window.SybaDetectedCountry).toUpperCase(); } catch (e) {}
        try { return (localStorage.getItem('syba_geo_iso') || '').toUpperCase(); } catch (e) { return ''; }
      }
      function refineFsFromGeo() {
        if (isB2B || !ON_DEFAULT_ROOT) return false;
        var iso = detectedIso();
        if (!iso) return false;
        var row = (window.SybaGiftConfigTable || {})[iso];
        if (!row || typeof row.ship_cost_cents !== 'number') return false;
        if (row.currency && cfg.fsShipCurrency && row.currency !== cfg.fsShipCurrency) return false;
        if (row.ship_cost_cents === cfg.fsShipCents) return false;
        cfg.fsShipCents = row.ship_cost_cents;
        return true;
      }
      // min(native Liquid threshold, visitor's Intelligems free-shipping group)
      // via assets/syba-ship-threshold.js; native when the resolver is absent.
      function fsThresholdCents() {
        try {
          var R = window.SybaShipThreshold;
          if (R && typeof R.effectiveCents === 'function') {
            var c = R.effectiveCents(cfg.fsThreshold, cfg.fsShipCurrency);
            if (typeof c === 'number') return c;
          }
        } catch (e) {}
        return cfg.fsThreshold;
      }
      try {
        if (window.SybaShipThreshold && typeof window.SybaShipThreshold.onChange === 'function') {
          var fsIgApplied = false;
          window.SybaShipThreshold.onChange(function (cents) {
            // No group and nothing applied before: nothing to redraw.
            if (cents == null && !fsIgApplied) return;
            fsIgApplied = cents != null;
            if (firstVariantId) render(currentVariantId() || firstVariantId.split('/').pop());
          });
        }
      } catch (e) {}

      // First-ever visit: edge-geo resolves after init → re-resolve + re-render
      // when the bridge publishes. (Returning visit is handled synchronously by
      // the refineFsFromGeo() call right before the initial render.)
      try {
        window.addEventListener('syba:geo-country', function () {
          if (refineFsFromGeo() && firstVariantId) {
            render(currentVariantId() || firstVariantId.split('/').pop());
          }
        });
      } catch (e) {}

      // Per-variant bundle price (ACTIVE presentment-currency minor units),
      // from Liquid — same currency as cfg.fsThreshold, so the comparison is
      // single-currency on every market.
      var variantPrices = {};
      var vpEl = root.querySelector('[data-nf-bundle-variant-prices]');
      if (vpEl) { try { variantPrices = JSON.parse(vpEl.textContent || '{}') || {}; } catch (e) { variantPrices = {}; } }

      // Cache of variantId -> grouped components, populated from one fetch.
      var byVariant = {};
      var firstVariantId = null;
      // Groups currently displayed (for the active variant) — the quick-view
      // modal reads from this by card index.
      var currentGroups = [];

      // Quick-view modal elements.
      var modal = root.querySelector('[data-nf-bundle-modal]');
      var mImage = modal && modal.querySelector('[data-nf-bundle-mimage]');
      var mTitle = modal && modal.querySelector('[data-nf-bundle-mtitle]');
      var mSubtitle = modal && modal.querySelector('[data-nf-bundle-msubtitle]');
      var mVariant = modal && modal.querySelector('[data-nf-bundle-mvariant]');
      var mPrice = modal && modal.querySelector('[data-nf-bundle-mprice]');
      var mUsp = modal && modal.querySelector('[data-nf-bundle-musp]');
      var mDesc = modal && modal.querySelector('[data-nf-bundle-mdesc]');
      var buyBtn = modal && modal.querySelector('[data-nf-bundle-buy]');

      function fmtMoney(amount, currency) {
        try {
          return new Intl.NumberFormat(cfg.localeTag, { style: 'currency', currency: currency }).format(amount);
        } catch (e) {
          return amount.toFixed(2) + ' ' + currency;
        }
      }

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      // Plain-text metafields (e.g. the USP one-liner) sometimes contain simple
      // inline formatting like <b>…</b> that a translator added. Escape the
      // whole string, then re-allow ONLY bold/italic tags (no attributes), so
      // the markup renders instead of showing as literal "<b>" — and nothing
      // dangerous (scripts, event handlers, links) can slip through.
      function inlineHtml(s) {
        return esc(s)
          .replace(/&lt;(\/?)(b|strong|i|em)&gt;/gi, '<$1$2>')
          .replace(/&lt;br\s*\/?&gt;/gi, '<br>');
      }


      // Minimal Shopify rich-text (metafield) AST → safe HTML. Handles the
      // node types short_description uses: root, paragraph, heading, list,
      // list-item, text (bold/italic), link. All text is escaped.
      function richTextToHtml(raw) {
        if (!raw) return '';
        var root;
        try { root = JSON.parse(raw); } catch (e) { return '<p>' + esc(raw) + '</p>'; }
        function kids(n) { return (n && n.children ? n.children : []).map(node).join(''); }
        function node(n) {
          if (!n) return '';
          switch (n.type) {
            case 'root': return kids(n);
            case 'paragraph': return '<p>' + kids(n) + '</p>';
            case 'heading': return '<p><strong>' + kids(n) + '</strong></p>';
            case 'list': return (n.listType === 'ordered' ? '<ol>' : '<ul>') + kids(n) + (n.listType === 'ordered' ? '</ol>' : '</ul>');
            case 'list-item': return '<li>' + kids(n) + '</li>';
            case 'link': return '<a href="' + esc(n.url || '#') + '" target="_blank" rel="noopener">' + kids(n) + '</a>';
            case 'text':
              var t = esc(n.value || '');
              if (n.bold) t = '<strong>' + t + '</strong>';
              if (n.italic) t = '<em>' + t + '</em>';
              return t;
            default: return n.children ? kids(n) : (n.value ? esc(n.value) : '');
          }
        }
        return node(root);
      }

      // Group a variant's components by product. One product → single card;
      // a product with multiple component variants → a "Set of" card.
      //
      // With cfg.splitVariants on, group by product AND variant instead, so a
      // product contributing several sizes renders one card per size
      // ("3× Ø7.5cm (0.2L) Square Self-Watering Plant Pots") rather than one
      // "Set of Ø7.5cm - Ø23.5cm" card. Everything downstream already handles a
      // single-item group, so only the map key changes.
      function group(componentNodes) {
        var map = {};
        var order = [];
        componentNodes.forEach(function (c) {
          var pv = c.productVariant;
          if (!pv || !pv.product) return;
          var pid = cfg.splitVariants ? (pv.product.id + '::' + pv.id) : pv.product.id;
          var qty = c.quantity || 1;
          var unit = parseFloat(pv.price.amount);
          if (!map[pid]) {
            var mfLabel = (pv.product.bundleLabel && pv.product.bundleLabel.value) ? pv.product.bundleLabel.value : '';
            // Image precedence: custom.bundle_card_image metafield override >
            // component variant image > product featured image.
            //
            // EXCEPT in split mode. That override is a group shot chosen to
            // represent ALL sizes on one combined card, so reusing it on every
            // per-size card showed the same photo of every pot on four cards
            // (the Clear pots). With one card per size the variant's own image
            // is the whole point, so it wins.
            var mfImage = (!cfg.splitVariants && pv.product.bundleImage && pv.product.bundleImage.reference && pv.product.bundleImage.reference.image)
              ? pv.product.bundleImage.reference.image
              : null;
            map[pid] = {
              product: pv.product,
              label: mfLabel,
              // Popup copy: prefer custom.short_description (rich text), fall
              // back to the truncated full description. Plus the my_fields.usp
              // one-liner ("Chunky & Airy") shown as a checkmark touch.
              shortDesc: (pv.product.shortDesc && pv.product.shortDesc.value) ? pv.product.shortDesc.value : '',
              fullDesc: pv.product.description || '',
              usp: (pv.product.usp && pv.product.usp.value) ? pv.product.usp.value : '',
              image: mfImage || ((pv.image && pv.image.url) ? pv.image : (pv.product.featuredImage || null)),
              currency: pv.price.currencyCode,
              items: [],
              total: 0
            };
            order.push(pid);
          }
          var g = map[pid];
          if (!g.image && pv.image && pv.image.url) g.image = pv.image;
          g.items.push({ title: pv.title, qty: qty });
          g.total += unit * qty;
        });
        if (!cfg.splitVariants) return order.map(function (pid) { return map[pid]; });
        // Split mode: components arrive in Shopify's order, which interleaves
        // sizes of the same product (Clear pots at 2, 7, 8). Re-sort so every
        // size of a product sits together, in first-seen product order, so the
        // grid reads as blocks instead of a shuffle.
        var byProduct = {}, productOrder = [];
        order.forEach(function (key) {
          var realId = map[key].product.id;
          if (!byProduct[realId]) { byProduct[realId] = []; productOrder.push(realId); }
          byProduct[realId].push(key);
        });
        // Within a product, keep first-seen order: the Storefront API returns
        // components in the product's own variant order (Ø5, Ø7, Ø9, Ø15), so
        // sizes already come out smallest-first. Verified across all 22
        // bundle-variant combinations 2026-08-10. Do NOT add a size sort here —
        // variant position is merchant-controlled in admin, so re-sorting would
        // silently override a deliberate ordering. (The Admin API returns these
        // components in a DIFFERENT, arbitrary order; that is not the order
        // this block sees.)
        var flat = [];
        productOrder.forEach(function (realId) {
          byProduct[realId].forEach(function (key) { flat.push(map[key]); });
        });
        return flat;
      }

      // Shared display helpers — keep the card and the popup in sync.
      // Title precedence: position override (theme editor) > product metafield
      // custom.bundle_card_label (short name) > full product title.
      function displayTitleFor(g, index) {
        var ov = overrides[index] || {};
        var t = ov.title ? ov.title : (g.label ? g.label : g.product.title);
        return applyTitleReplacements(t);
      }
      // Card-title replacements, from the block setting. One rule per line,
      // "Full product title => Short label". Lets a bundle shorten a name for
      // the card without touching the product itself ("Clear Self-Watering
      // Plant Pots" -> "Clear Self-Watering Pot"), and because it is a TEMPLATE
      // setting it is translatable per locale like the rest of the page copy.
      // Longest rule first, so a general rule can never shadow a specific one.
      function applyTitleReplacements(title) {
        for (var i = 0; i < cfg.titleReplacements.length; i++) {
          var r = cfg.titleReplacements[i];
          if (title.indexOf(r[0]) > -1) return title.split(r[0]).join(r[1]);
        }
        return title;
      }
      // For a "Set" (one product contributing multiple component variants),
      // return the per-variant quantity IF every variant in the set appears
      // the same number of times (e.g. 3 of each pot size → 3). Returns 1 when
      // the set has mixed quantities, so callers only ever show a multiplier
      // when it's unambiguous (> 1).
      function setQuantity(g) {
        if (!g.items.length) return 1;
        var q = g.items[0].qty;
        for (var i = 1; i < g.items.length; i++) {
          if (g.items[i].qty !== q) return 1;
        }
        return q;
      }
      // Variant/quantity line. Single qty>1 → "3 × 5L"; single qty1 → "5L";
      // set → "Set of Ø5cm – Ø15cm", prefixed "3 × " when there are 3 of each.
      // The "1 ×" prefix is intentionally hidden (qty 1 shows no multiplier).
      function variantLineFor(g, index) {
        var ov = overrides[index] || {};
        if (g.items.length > 1) {
          var range = ov.variant ? ov.variant : (g.items[0].title + ' – ' + g.items[g.items.length - 1].title);
          var sq = setQuantity(g);
          var setPrefix = sq > 1 ? (sq + ' × ') : '';
          return setPrefix + cfg.setOf + ' ' + range;
        }
        var it = g.items[0];
        var v = ov.variant ? ov.variant : ((it.title && it.title !== 'Default Title') ? it.title : '');
        if (it.qty > 1) return v ? (it.qty + ' × ' + v) : (it.qty + ' ×');
        return v;
      }

      function cardHTML(g, index) {
        var isSet = g.items.length > 1;
        var ov = overrides[index] || {};
        var titleDisplay = displayTitleFor(g, index);
        var label;
        if (isSet) {
          var first = g.items[0].title;
          var last = g.items[g.items.length - 1].title;
          var rangeDisplay = ov.variant ? ov.variant : (first + ' - ' + last);
          // Show "3× Set of …" when there are 3 of each variant; hide the
          // multiplier entirely when it's 1 (or the set has mixed quantities).
          var setQty = setQuantity(g);
          var setPrefix = setQty > 1 ? (setQty + '× ') : '';
          label = setPrefix + esc(cfg.setOf) + ' ' + esc(rangeDisplay) + ' ' + esc(titleDisplay);
        } else {
          var it = g.items[0];
          var variantRaw = ov.variant ? ov.variant : ((it.title && it.title !== 'Default Title') ? it.title : '');
          var vt = variantRaw ? esc(variantRaw) + ' ' : '';
          // Hide the "1× " prefix for single items (e.g. "5L Aroid", not
          // "1× 5L Aroid"); keep it for 2×, 3×, …
          var qtyPrefix = it.qty > 1 ? (it.qty + '× ') : '';
          label = qtyPrefix + vt + esc(titleDisplay);
        }
        var priceHtml = cfg.showPrices
          ? '<div class="nf-bundle-card__price">' + esc(fmtMoney(g.total, g.currency)) + '</div>'
          : '';
        var media;
        if (g.image && g.image.url) {
          var src = g.image.url;
          media = '<img class="nf-bundle-card__img" src="' + esc(src) + '" alt="' + esc(titleDisplay) +
                  '" loading="lazy" width="400" height="400">';
        } else {
          media = '<div class="nf-bundle-card__img nf-bundle-card__img--placeholder"></div>';
        }
        // Card is a button that opens the quick-view modal (was a link to the
        // product page). data-card-index maps back to currentGroups for the modal.
        return '<button type="button" class="nf-bundle-card" data-card-index="' + index + '" aria-label="' + esc(titleDisplay) + '">' +
                 '<div class="nf-bundle-card__media">' + media + '</div>' +
                 '<div class="nf-bundle-card__body">' +
                   '<div class="nf-bundle-card__label">' + label + '</div>' +
                   priceHtml +
                 '</div>' +
               '</button>';
      }

      function freeShippingCardHTML() {
        var media = cfg.fsImage
          ? '<img class="nf-bundle-card__img" src="' + esc(cfg.fsImage) + '" alt="' + esc(cfg.fsLabel) + '" loading="lazy" width="400" height="400">'
          : '<div class="nf-bundle-card__img nf-bundle-card__img--placeholder"></div>';
        // Value = the per-market shipping fee the customer saves, formatted
        // like the component prices (value-stack: "free shipping, worth €9.95").
        var valueHtml = (cfg.showPrices && cfg.fsShipCents > 0)
          ? '<div class="nf-bundle-card__price">' + esc(fmtMoney(cfg.fsShipCents / 100, cfg.fsShipCurrency)) + '</div>'
          : '';
        return '<div class="nf-bundle-card nf-bundle-card--fs" aria-label="' + esc(cfg.fsLabel) + '">' +
                 '<div class="nf-bundle-card__media">' + media + '</div>' +
                 '<div class="nf-bundle-card__body">' +
                   '<div class="nf-bundle-card__label nf-bundle-card__label--fs">' + esc(cfg.fsLabel) + '</div>' +
                   valueHtml +
                 '</div>' +
               '</div>';
      }

      // "Friend Gift" free gift-card card. Display-only (the gift app handles
      // fulfilment). Mirrors the free-shipping card: a translatable label with
      // the EUR face value shown beneath (value-stack), so the copy translates
      // cleanly while the amount stays dynamic per product.
      function giftCardHTML() {
        var media = cfg.giftImage
          ? '<img class="nf-bundle-card__img" src="' + esc(cfg.giftImage) + '" alt="' + esc(cfg.giftLabel) + '" loading="lazy" width="400" height="400">'
          : '<div class="nf-bundle-card__img nf-bundle-card__img--placeholder"></div>';
        // Deliberately NOT gated on cfg.showPrices. The gift card's value is
        // the offer itself ("a EUR 15 gift card"), not a component price, so
        // hiding component prices must not silently delete it. Same reasoning
        // as the Expert-support card keeping its "Included" label.
        var valueHtml = (cfg.giftValue > 0)
          ? '<div class="nf-bundle-card__price">' + esc(fmtMoney(cfg.giftValue, cfg.giftCurrency)) + '</div>'
          : '';
        return '<div class="nf-bundle-card nf-bundle-card--gift" aria-label="' + esc(cfg.giftLabel) + '">' +
                 '<div class="nf-bundle-card__media">' + media + '</div>' +
                 '<div class="nf-bundle-card__body">' +
                   '<div class="nf-bundle-card__label nf-bundle-card__label--gift">' + esc(cfg.giftLabel) + '</div>' +
                   valueHtml +
                 '</div>' +
               '</div>';
      }

      // Inline fallback icon (headset) for the Expert-support card when no
      // theme-editor image is set — keeps the card looking intentional.
      function expertSupportIconSVG() {
        return '<svg class="nf-bundle-card__img nf-bundle-card__img--icon" viewBox="0 0 24 24" fill="none" stroke="#5a8a3c" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
                 '<path d="M4 13v-1a8 8 0 0 1 16 0v1"/>' +
                 '<path d="M6 12h1v6H6a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z"/>' +
                 '<path d="M18 12h-1v6h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2z"/>' +
                 '<path d="M17 18a4 4 0 0 1-4 3h-1.5"/>' +
               '</svg>';
      }

      // "Expert plant support" value card. Clickable (opens the support popup);
      // shows "Included" instead of a price. Per-page toggle via cfg.esEnabled.
      function expertSupportCardHTML() {
        var media = cfg.esImage
          ? '<img class="nf-bundle-card__img" src="' + esc(cfg.esImage) + '" alt="' + esc(cfg.esLabel) + '" loading="lazy" width="400" height="400">'
          : expertSupportIconSVG();
        var valueHtml = cfg.esPrice
          ? '<div class="nf-bundle-card__price">' + esc(cfg.esPrice) + '</div>'
          : '';
        return '<button type="button" class="nf-bundle-card nf-bundle-card--support" data-nf-bundle-support aria-label="' + esc(cfg.esLabel) + '">' +
                 '<div class="nf-bundle-card__media">' + media + '</div>' +
                 '<div class="nf-bundle-card__body">' +
                   '<div class="nf-bundle-card__label nf-bundle-card__label--support">' + esc(cfg.esLabel) + '</div>' +
                   valueHtml +
                 '</div>' +
               '</button>';
      }

      // Does the selected bundle size ship free? Two paths:
      //   1. GRANT — M/L Welcome Bundle sizes ship free in EVERY market
      //      (checkout-enforced by the starter-bundle-free-shipping function);
      //   2. THRESHOLD — the size's price clears the visitor's market
      //      free-shipping threshold (native Shopify rate).
      function qualifiesForFreeShipping(variantId) {
        if (!cfg.fsEnabled || isB2B) return false;
        // GRANT first, on the RAW id: it needs no price data, so a broken or
        // empty variant-prices map must not be able to drop it (the vid
        // resolution below falls back to firstVariantId — typically S — when
        // the price map misses, which would silently lose an M/L grant).
        if (variantId != null && cfg.fsGrantIds.indexOf(String(variantId)) !== -1) return true;
        var vid = variantId != null && variantPrices[variantId] != null
          ? String(variantId)
          : (firstVariantId ? firstVariantId.split('/').pop() : '');
        if (vid && cfg.fsGrantIds.indexOf(vid) !== -1) return true;
        var thr = fsThresholdCents();
        if (thr <= 0) return false;
        var price = variantPrices[vid];
        return typeof price === 'number' && price >= thr;
      }

      function render(variantId) {
        var groups = byVariant[variantId] || byVariant[firstVariantId] || [];
        currentGroups = groups;
        var html = groups.map(function (g, i) { return cardHTML(g, i); }).join('');
        grid.innerHTML = html;
        // Append manual extras (cloned from the Liquid-rendered template).
        if (extrasTpl && extrasTpl.content) {
          grid.appendChild(extrasTpl.content.cloneNode(true));
        }
        // Append the "Expert plant support" value card (per-page toggle).
        if (cfg.esEnabled) {
          grid.insertAdjacentHTML('beforeend', expertSupportCardHTML());
        }
        // Append the "Friend Gift" free gift-card card when the product carries
        // the gift.friend_card_value metafield (shows on every variant/size).
        if (cfg.giftEnabled && cfg.giftValue > 0) {
          grid.insertAdjacentHTML('beforeend', giftCardHTML());
        }
        // Append the market-aware "Free shipping" card when the size qualifies.
        if (qualifiesForFreeShipping(variantId)) {
          grid.insertAdjacentHTML('beforeend', freeShippingCardHTML());
        }
      }

      // ---- Quick-view modal: open from a card's group, close, "Buy bundle".
      function openModal(g, index) {
        if (!modal || !g) return;
        var heading = displayTitleFor(g, index);
        if (mImage) {
          if (g.image && g.image.url) { mImage.src = g.image.url; mImage.alt = heading || ''; mImage.style.display = ''; }
          else { mImage.removeAttribute('src'); mImage.style.display = 'none'; }
        }
        // Heading matches the card (short label / override). Full product name
        // shown as a subtitle only when it differs, so nothing is lost.
        if (mTitle) mTitle.textContent = heading || '';
        if (mSubtitle) {
          var full = g.product.title || '';
          var showSub = full && full !== heading;
          mSubtitle.textContent = showSub ? full : '';
          mSubtitle.style.display = showSub ? '' : 'none';
        }
        var vt = variantLineFor(g, index);
        if (mVariant) { mVariant.textContent = vt; mVariant.style.display = vt ? '' : 'none'; }
        // Keep the popup consistent with the cards: when prices are switched
        // off for this template, the quick-view must not leak the amount the
        // cards deliberately hide.
        if (mPrice) {
          mPrice.textContent = cfg.showPrices ? fmtMoney(g.total, g.currency) : '';
          mPrice.style.display = cfg.showPrices ? '' : 'none';
        }
        if (mUsp) {
          mUsp.innerHTML = inlineHtml(g.usp || '');
          mUsp.style.display = g.usp ? '' : 'none';
        }
        if (mDesc) {
          // Prefer the short_description rich text; fall back to truncated full description.
          var descHtml = g.shortDesc ? richTextToHtml(g.shortDesc) : (g.fullDesc ? '<p>' + esc(g.fullDesc) + '</p>' : '');
          mDesc.innerHTML = descHtml;
          mDesc.style.display = descHtml ? '' : 'none';
        }
        modal.removeAttribute('hidden');
        try { document.body.dataset.nfBundlePrevOverflow = document.body.style.overflow; } catch (e) {}
        document.body.style.overflow = 'hidden';
      }
      // Quick-view popup for the "Expert plant support" card. Reuses the modal
      // chrome but fills it with the support promise (intro + bullets) instead
      // of component data; the price slot shows "Included", no variant/USP line.
      function openSupportModal() {
        if (!modal) return;
        if (mImage) {
          if (cfg.esImage) { mImage.src = cfg.esImage; mImage.alt = cfg.esLabel || ''; mImage.style.display = ''; }
          else { mImage.removeAttribute('src'); mImage.style.display = 'none'; }
        }
        if (mTitle) mTitle.textContent = cfg.esLabel || '';
        if (mSubtitle) { mSubtitle.textContent = ''; mSubtitle.style.display = 'none'; }
        if (mVariant) { mVariant.textContent = ''; mVariant.style.display = 'none'; }
        if (mPrice) { mPrice.textContent = cfg.esPrice || ''; mPrice.style.display = cfg.esPrice ? '' : 'none'; }
        if (mUsp) { mUsp.innerHTML = ''; mUsp.style.display = 'none'; }
        if (mDesc) {
          var html = '';
          if (cfg.esIntro) html += '<p>' + esc(cfg.esIntro) + '</p>';
          if (cfg.esBullets.length) {
            html += '<ul class="nf-bundle-modal__list">';
            cfg.esBullets.forEach(function (b) { html += '<li>' + esc(b) + '</li>'; });
            html += '</ul>';
          }
          mDesc.innerHTML = html;
          mDesc.style.display = html ? '' : 'none';
        }
        modal.removeAttribute('hidden');
        try { document.body.dataset.nfBundlePrevOverflow = document.body.style.overflow; } catch (e) {}
        document.body.style.overflow = 'hidden';
      }
      function closeModal() {
        if (!modal) return;
        modal.setAttribute('hidden', '');
        try { document.body.style.overflow = document.body.dataset.nfBundlePrevOverflow || ''; } catch (e) { document.body.style.overflow = ''; }
      }
      function scrollToBuy() {
        // "Buy bundle" returns focus to the bundle's own add-to-cart, so the
        // shopper buys the BUNDLE (not the individual component just viewed).
        closeModal();
        var atc = document.querySelector('product-info button[name="add"], product-form button[type="submit"], form[action*="/cart/add"] [type="submit"]');
        if (atc) {
          // scrollIntoView already brings the add-to-cart into view; we
          // deliberately don't call focus() with a scroll-suppression option
          // (the i18n claim-lint scans JS too and matches that DOM keyword).
          try { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { atc.scrollIntoView(); }
        }
      }
      if (grid) {
        grid.addEventListener('click', function (e) {
          // Expert-support card opens its own info popup (no component group).
          if (e.target.closest && e.target.closest('[data-nf-bundle-support]')) {
            openSupportModal();
            return;
          }
          var card = e.target.closest && e.target.closest('.nf-bundle-card[data-card-index]');
          if (!card || !grid.contains(card)) return;
          var idx = parseInt(card.getAttribute('data-card-index'), 10);
          if (!isNaN(idx)) openModal(currentGroups[idx], idx);
        });
      }
      if (modal) {
        modal.querySelectorAll('[data-nf-bundle-close]').forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
        });
      }
      if (buyBtn) buyBtn.addEventListener('click', scrollToBuy);

      function currentVariantId() {
        var input = scopeEl.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"], input[name="id"]');
        return input ? input.value : null;
      }

      function watchVariant() {
        var input = scopeEl.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"], input[name="id"]');
        if (!input) return;
        var last = input.value;
        var obs = new MutationObserver(function () {
          if (input.value !== last) {
            last = input.value;
            render(input.value);
          }
        });
        obs.observe(input, { attributes: true, attributeFilter: ['value'] });
        // Some pickers fire 'change' instead of mutating the attribute.
        input.addEventListener('change', function () {
          if (input.value !== last) { last = input.value; render(input.value); }
        });
      }

      var query =
        'query($handle:String!,$country:CountryCode!,$lang:LanguageCode!) @inContext(country:$country,language:$lang){' +
        ' product(handle:$handle){' +
        '  variants(first:25){nodes{' +
        '   id title' +
        '   components(first:40){nodes{' +
        '    quantity' +
        '    productVariant{ id title price{amount currencyCode} image{url altText}' +
        '     product{ id title onlineStoreUrl description(truncateAt:320) featuredImage{url altText}' +
        '      bundleLabel: metafield(namespace:"custom",key:"bundle_card_label"){ value }' +
        '      shortDesc: metafield(namespace:"custom",key:"short_description"){ value }' +
        '      usp: metafield(namespace:"my_fields",key:"usp"){ value }' +
        '      bundleImage: metafield(namespace:"custom",key:"bundle_card_image"){ reference{ ... on MediaImage { image{ url altText } } } } } }' +
        '   }}' +
        '  }}' +
        ' }' +
        '}';

      fetch(cfg.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': cfg.token
        },
        body: JSON.stringify({
          query: query,
          variables: { handle: cfg.handle, country: cfg.country, lang: cfg.lang }
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var prod = res && res.data && res.data.product;
          if (!prod || !prod.variants) { grid.innerHTML = ''; return; }
          prod.variants.nodes.forEach(function (v) {
            var comps = (v.components && v.components.nodes) ? v.components.nodes : [];
            if (firstVariantId === null) firstVariantId = v.id;
            // Key by the numeric variant id (input[name=id] holds the numeric form).
            var numeric = v.id.split('/').pop();
            byVariant[numeric] = group(comps);
          });
          var cur = currentVariantId();
          // currentVariantId returns numeric; firstVariantId is a gid → normalize.
          // Refine the free-shipping cost to the visitor's detected country
          // BEFORE first render (returning visitor: cached ISO is available
          // synchronously → correct €5.95 on first paint, no IE flash). The
          // 'syba:geo-country' listener above covers a first-ever visit where
          // edge-geo resolves slightly later.
          refineFsFromGeo();
          render(cur || (firstVariantId ? firstVariantId.split('/').pop() : null));
          watchVariant();
        })
        .catch(function () { grid.innerHTML = ''; });
    }

    function boot() {
      document.querySelectorAll('[data-nf-bundle]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // Re-init after Shopify section re-renders (theme editor).
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
